import { render, staticRenderFns } from "./CoachAccordionSettings.vue?vue&type=template&id=cb9937e6&scoped=true&"
import script from "./CoachAccordionSettings.vue?vue&type=script&lang=ts&"
export * from "./CoachAccordionSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CoachAccordionSettings.vue?vue&type=style&index=0&id=cb9937e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9937e6",
  null
  
)

export default component.exports